export const HIGHLIGHT_CARD_TYPES = {
  LEAST_MISSED_QUESTION: 'LEAST_MISSED_QUESTION',
  MOST_MISSED_QUESTION: 'MOST_MISSED_QUESTION',
  HIGHEST_SCORING_METHODOLOGY: 'HIGHEST_SCORING_METHODOLOGY',
  LOWEST_SCORING_METHODOLOGY: 'LOWEST_SCORING_METHODOLOGY',
  LEAST_ARTICULATED_MESSAGE: 'LEAST_ARTICULATED_MESSAGE',
  MOST_ARTICULATED_MESSAGE: 'MOST_ARTICULATED_MESSAGE',
  USER_ENGAGEMENT: 'USER_ENGAGEMENT',
  USER_ENGAGEMENT_NEGATIVE: 'USER_ENGAGEMENT_NEGATIVE',
  LEAST_MISSED_ANSWER_POINT: 'LEAST_MISSED_ANSWER_POINT',
  MOST_MISSED_ANSWER_POINT: 'MOST_MISSED_ANSWER_POINT',
} as const;

export const HIGHLIGHT_CARD_HEADINGS: Record<string, string> = {
  [HIGHLIGHT_CARD_TYPES.LEAST_MISSED_QUESTION]: 'LEAST MISSED QUESTION',
  [HIGHLIGHT_CARD_TYPES.MOST_MISSED_QUESTION]: 'MOST MISSED QUESTION',
  [HIGHLIGHT_CARD_TYPES.HIGHEST_SCORING_METHODOLOGY]: 'HIGHEST SCORING METHODOLOGY SECTION',
  [HIGHLIGHT_CARD_TYPES.LOWEST_SCORING_METHODOLOGY]: 'LOWEST SCORING METHODOLOGY SECTION',
  [HIGHLIGHT_CARD_TYPES.LEAST_ARTICULATED_MESSAGE]: 'LEAST ARTICULATED MESSAGE',
  [HIGHLIGHT_CARD_TYPES.MOST_ARTICULATED_MESSAGE]: 'MOST ARTICULATED MESSAGE',
  [HIGHLIGHT_CARD_TYPES.USER_ENGAGEMENT]: 'ENGAGEMENT',
  [HIGHLIGHT_CARD_TYPES.LEAST_MISSED_ANSWER_POINT]: 'LEAST MISSED ANSWER POINT',
  [HIGHLIGHT_CARD_TYPES.MOST_MISSED_ANSWER_POINT]: 'MOST MISSED ANSWER POINT',

};

export const HIGHLIGHT_CARD_PROGRESS_DESCRIPTIONS: Record<string, string> = {
  [HIGHLIGHT_CARD_TYPES.USER_ENGAGEMENT]: 'more sessions completed than team average',
  [HIGHLIGHT_CARD_TYPES.USER_ENGAGEMENT_NEGATIVE]: 'less sessions completed than team average',
  [HIGHLIGHT_CARD_TYPES.MOST_MISSED_QUESTION]: 'of the time, this user got this right',
  [HIGHLIGHT_CARD_TYPES.LEAST_MISSED_QUESTION]: 'of the time, this user got this right',
  [HIGHLIGHT_CARD_TYPES.LEAST_ARTICULATED_MESSAGE]: 'of the time, this user got this right',
  [HIGHLIGHT_CARD_TYPES.MOST_ARTICULATED_MESSAGE]: 'Fully articulate this message',
  [HIGHLIGHT_CARD_TYPES.HIGHEST_SCORING_METHODOLOGY]: 'avg. points on this objective',
  [HIGHLIGHT_CARD_TYPES.LOWEST_SCORING_METHODOLOGY]: 'avg. points on this objective',
  [HIGHLIGHT_CARD_TYPES.LEAST_MISSED_ANSWER_POINT]: 'of the time, users get this right',
  [HIGHLIGHT_CARD_TYPES.MOST_MISSED_ANSWER_POINT]: 'of the time, users get this right',
};
